import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const ImageOverlay = styled.div`
    align-items: center;
    display: none;
    position: absolute;

    @media ${breakpoints.extraLarge} {
        display: inline;
        left: ${({ align }) => (align === 'left' ? '-38px' : undefined)};
        right: ${({ align }) => (align === 'right' ? '-59px' : undefined)};
    }
`;
